import Flex from "components/Flex";

import { DelightedStartsFeedbackProps, useDelightedSurvey } from "hooks/useDelightedSurvey";

export const DelightedStarsFeedback = ({ clientId, sessionId }: Omit<DelightedStartsFeedbackProps, "surveyType">) => {
  const surveyType = "delightedStars";
  useDelightedSurvey({ clientId, sessionId, surveyType });

  return (
    // Keep the same space of the Tractable Feedback survey
    <Flex
      px={24}
      pt={24}
      pb={36}
      style={{
        bottom: 0,
      }}
    >
      <div />
    </Flex>
  );
};
